import React from "react";
import {UserDispatchContext} from '../providers';

function useDispatchUser() {
    return React.useContext(UserDispatchContext);
}

export {useDispatchUser}
